<template>
				<!-- <header class="mdc-top-app-bar position-static">
					<div class="mdc-top-app-bar__row">
						<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-start">
							<a class="material-icons mdc-top-app-bar__navigation-icon" @click="closeNotice()">close</a>
						</section>
						
						<section class="mdc-top-app-bar__section title">
							<div class="mdc-top-app-bar__title">
								{{$t('602')}}
							</div>                
						</section>
						<section class="mdc-top-app-bar__section mdc-top-app-bar__section--align-end">
							<a class="material-icons mdc-top-app-bar__action-item" aria-label="search" alt="search"></a>
						</section>
					</div>
				</header> -->
		<main class="main-wrapper flex-grow-1 ">
			<div class="container container--narrow pdt-50 pdb-50">
				<div class="border b-radius4 pda-36">
				<div class="t-headline10 font-b ">{{$t('602')}}</div>
				<div class="mgt-24 bg-shadow2 h-2"></div>
				<div class="t-body1 t-color-bodyGrayA new-body-color font-r t-line-h-26" v-html="noticeData.contents">
				</div>
				</div>
				<div class="mgt-50 mgb-50 ">
					<button @click="closeNotice" @keypress="closeNotice" tabindex="0" class="mdc-button mdc-button--raised bg-mainBtn t-color-mainBtnText mgr-8">
						<div class="mdc-button__ripple"></div>
						<span class="mdc-button__label t-body2 font-r">{{ $t('603') }}</span>
					</button>
				</div>
			</div>
		</main>
</template>
<script>

/**
 * 차수 상세 공지사항 팝업 컴포넌트(degree view Notice popup component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCRipple} from '@material/ripple'
import TopAppBarDrawer from "@/components/TopAppBarDrawer.vue";
import TopAppBar from '@/components/TopAppBar.vue'
import {topAppBarMixin} from '@/mixins/topAppBar.js'
export default {
	props: ['noticeData'],
	data(){
		return {
		brandName : localStorage.getItem('brandName'),
	//	noticeData : ''
		}
	},
	components:{
		TopAppBar,
		TopAppBarDrawer
	},
	mixins: [topAppBarMixin],
	mounted() {
	//	this.noticeData = JSON.parse(localStorage.getItem("campaignData"));
	//	console.log(this.noticeData, ' __this.noticeData')
		this.setMaterialUi();
	},
	methods: {
		// 공지사항 닫기(close Notice)
		closeNotice() {
			this.$emit('closeNotice')
		},
		setMaterialUi() {
			const buttonRipple = [].map.call(document.querySelectorAll('.mdc-button'), function(el) {
				let button = new MDCRipple.attachTo(el)
				return button
			})

		},
	}
}
</script>
<style scoped>
.new-body-color img {
	width:100%!important;
}
</style>